import { render } from "./CatalogoMarcoView.vue?vue&type=template&id=5854aaf3&ts=true"
import script from "./CatalogoMarcoView.vue?vue&type=script&lang=ts"
export * from "./CatalogoMarcoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__